import { getSession } from 'next-auth/client';

export default getSession;
